import { PageBlueprint } from '@backstage/frontend-plugin-api';
import { convertLegacyPlugin } from '@backstage/core-compat-api';
import { FeatureFlagGate } from '@internal/plugin-feature-flags-common/components';
import { GOLDEN_PATHS_FEATURE_FLAG } from '@internal/plugin-feature-flags-common';
import { goldenPathsPlugin } from './plugin';

const goldenPathsListPage = PageBlueprint.make({
  name: 'list',
  params: {
    path: '/golden-paths',
    noHeader: true,
    loader: () =>
      import('./components/GoldenPathsListPage').then(m => (
        <FeatureFlagGate flag={GOLDEN_PATHS_FEATURE_FLAG}>
          <m.GoldenPathsListPage />
        </FeatureFlagGate>
      )),
  },
});

const goldenPathsCreatePage = PageBlueprint.make({
  name: 'create',
  params: {
    path: '/golden-paths/new',
    noHeader: true,
    loader: () =>
      import('./components/GoldenPathCreatePage').then(m => (
        <FeatureFlagGate flag={GOLDEN_PATHS_FEATURE_FLAG}>
          <m.GoldenPathCreatePage />
        </FeatureFlagGate>
      )),
  },
});

const goldenPathsDetailPage = PageBlueprint.make({
  name: 'detail',
  params: {
    path: '/golden-paths/:slug',
    noHeader: true,
    loader: () =>
      import('./components/GoldenPathDetailPage').then(m => (
        <FeatureFlagGate flag={GOLDEN_PATHS_FEATURE_FLAG}>
          <m.GoldenPathDetailPage />
        </FeatureFlagGate>
      )),
  },
});

const goldenPathsEditPage = PageBlueprint.make({
  name: 'edit',
  params: {
    path: '/golden-paths/:slug/edit',
    noHeader: true,
    loader: () =>
      import('./components/GoldenPathEditPage').then(m => (
        <FeatureFlagGate flag={GOLDEN_PATHS_FEATURE_FLAG}>
          <m.GoldenPathEditPage />
        </FeatureFlagGate>
      )),
  },
});

export default convertLegacyPlugin(goldenPathsPlugin, {
  extensions: [
    goldenPathsListPage,
    goldenPathsCreatePage,
    goldenPathsDetailPage,
    goldenPathsEditPage,
  ],
});
